import { useEffect, useState } from 'react';

export type WindowSize = [width: number, height: number];

const useWindowSize = (): WindowSize => {
  const [size, setSize] = useState<WindowSize>([
    window.innerWidth,
    window.innerHeight,
  ]);

  useEffect(() => {
    const resizeHandler = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', resizeHandler);

    return () => window.removeEventListener('resize', resizeHandler);
  }, []);

  return size;
};

export default useWindowSize;
